import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";

import "./loguin.css";
import removeCokies from "./removeCokies.js";
import seteaCokie from "./seteaCookieFirstStep.js";
import { Spinner } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import FooterCorp from "../modulos/footerCorp.jsx";
import LogueMovimientos from "./LogueMovimientos.jsx";

const cookies = new Cookies();
const UR_usuarios = process.env.REACT_APP_BASEURL + "usuariosLoguin/";

function Loguin() {
  const [isVisible, setIsVisible] = useState(false);
  const [cargando, setCargando] = useState(false);
  const navigate = useNavigate();

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({});

  useEffect(() => {
    removeCokies();
    localStorage.removeItem("ultimaVistaNotificaciones");

    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 50);

    return () => clearTimeout(timer);
  }, []);

  const mostrarError = (titulo, texto = "") => {
    Swal.fire({
      icon: "error",
      title: titulo,
      text: texto,
      confirmButtonText: "Aceptar",
    });
  };

  const loguin = async (cosa) => {
    try {
      setCargando(true);

      const token = btoa(
        `${process.env.REACT_APP_KEY}:${process.env.REACT_APP_PASS}`
      );

      const estaAbierto = await axios.post(
        UR_usuarios + cosa.usuario,
        {
          pass: cosa.pass,
          versionSIGEDI: process.env.REACT_APP_VERSION,
        },
        {
          headers: {
            Authorization: `Basic ${token}`,
          },
        }
      );

      const data = estaAbierto.data;

      if (!data) {
        mostrarError("Usuario no encontrado");
        return;
      }

      if (data.success === false) {
        mostrarError(data.message || "Credenciales inválidas");
        return;
      }

      if (data.versionSIGEDI !== process.env.REACT_APP_VERSION) {
        await Swal.fire({
          icon: "warning",
          title: "Versión obsoleta",
          text: "Vamos a recargar la página para actualizar SIGEDI.",
          confirmButtonText: "Recargar",
        });

        window.location.reload(true);
        return;
      }

      if (Number(data.estado) !== 1) {
        mostrarError("Usuario no habilitado");
        return;
      }
cookies.set("usuario", cosa.usuario, { path: "/" });

// Guardamos la sesión nueva.
const sesionGuardada = seteaCokie(data);

if (!sesionGuardada) {
  mostrarError("No se pudo guardar la sesión");
  return;
}

// Compatibilidad con los módulos anteriores de SIGEDI.
cookies.set("id", data.id, { path: "/" });
cookies.set("identificacion", data.identificacion ?? data.dni, { path: "/" });
cookies.set("nombre", data.nombre ?? "", { path: "/" });
cookies.set("apellidoUsuario", data.apellido ?? "", { path: "/" });
cookies.set("sedeID", data.sedeID, { path: "/" });
cookies.set("destino", data.destino, { path: "/" });
cookies.set("nivel", data.nivel, { path: "/" });
cookies.set("estado", data.estado, { path: "/" });
cookies.set("funcion", data.funcion ?? "", { path: "/" });

      await Swal.fire({
        icon: "success",
        title: "Ingreso correcto",
        text: `Bienvenido ${data.nombre || ""}`,
        timer: 1200,
        showConfirmButton: false,
      });

      if (Number(data.blanqueoContrasena) === 1) {
        navigate("./cambioContrasena");
      } else {
        LogueMovimientos(data, "Ingresa a SIGEDI");
        navigate("./usuarioLogueado");
      }
    } catch (error) {
      console.error("ERROR FRONT LOGIN:", error);

      if (error.code === "ERR_NETWORK") {
        mostrarError(
          "Sin conexión al servidor",
          "No conectó al SERVER, espera para las consultas."
        );
      } else {
        mostrarError(
          "Error al iniciar sesión",
          error?.response?.data?.message || "Intente nuevamente."
        );
      }
    } finally {
      setCargando(false);
    }
  };

  return (
    /* Wrapper contenedor aislado */
    <div className="login-page-wrapper">
      <div className="form__loguin_ingreso">
        <div className={`imagen_loguin box ${isVisible ? "show" : ""}`}>
          <h3
            style={{
              textAlign: "center",
              margin: "50px",
              color: "white",
            }}
          >
            Sistema Interno de Gestión y Expedientes Digitales I.Se.P
          </h3>
        </div>

        <form className="form_use" onSubmit={handleSubmit(loguin)}>
          <div className="form__container">
            <div className="escudo_loguin"></div>

            <div>{cargando && <Spinner color="primary" />}</div>

            <h4 className="form__title_Important">
              Instituto de Seguridad Pública
            </h4>

            <div className="form__group">
              {errors.usuario?.type === "required" && (
                <span className="aviso-campos-loguin">*</span>
              )}

              <input
                type="text"
                placeholder=" "
                className="form__input"
                id="usuario"
                autoComplete="username"
                disabled={cargando}
                {...register("usuario", {
                  required: true,
                  minLength: 6,
                  maxLength: 8,
                })}
              />

              <label htmlFor="usuario" className="form__label">
                Usuario
              </label>

              <span className="form__line"></span>
            </div>

            <div className="form__group">
              {errors.pass?.type === "required" && (
                <span className="aviso-campos-loguin">*</span>
              )}

              <input
                className="form__input"
                id="pass"
                type="password"
                placeholder=" "
                autoComplete="current-password"
                disabled={cargando}
                {...register("pass", {
                  required: true,
                })}
              />

              <label htmlFor="pass" className="form__label">
                Contraseña
              </label>

              <span className="form__line"></span>
            </div>

            <input
              type="submit"
              className="form__submit"
              value={cargando ? "Ingresando..." : "Ingresar"}
              disabled={cargando}
            />

            <h6
              style={{
                textAlign: "center",
                margin: "-20px",
                fontSize: "10px",
              }}
            >
              <strong>S.I.G.E.D.I</strong>{" "}
              {process.env.REACT_APP_VERSION}
            </h6>

            <FooterCorp />
          </div>
        </form>
      </div>
    </div>
  );
}

export default Loguin;